/* eslint-disable react/jsx-closing-tag-location */
import { Col, Input, Row } from 'antd'
import React, { useEffect, useState } from 'react'
import _ from 'lodash'
import { squadronHelper, matchData } from '../../../../shared/pools'

import './css/print-pools.css'

const PrintPools = React.forwardRef((props, ref) => {
  const [pools, setPools] = useState([])

  useEffect(() => {
    const poolsToPrint = []
    if (props.sheetLayout === 'c' || props.sheetLayout === 'd') {
      props.pools.forEach(pool => {
        const participantMatches = new Array(pool?.participants?.length).fill()
        const matchList = new Array(pool?.participants?.length).fill(participantMatches)
        poolsToPrint.push({
          pool,
          matches: matchList,
          sheets: sheetBreaks(pool)
        })
      })
    } else {
      const participantMatches = new Array(props?.pool?.participants?.length).fill()
      const matchList = new Array(props?.pool?.participants?.length).fill(participantMatches)
      poolsToPrint.push({
        pool: props?.pool,
        matches: matchList,
        sheets: sheetBreaks(props.pool)
      })
    }
    setPools(poolsToPrint)
    // eslint-disable-next-line
  }, [props.sheetLayout])

  const getMatchNumber = (participants, a, b) => {
    const numberParticipants = participants
    if (numberParticipants < 2 || numberParticipants > 20 || _.isUndefined(a) || _.isUndefined(b)) {
      return ''
    }
    const matchNumber = matchData[numberParticipants].findIndex(f => (f[0] === a + 1 || f[0] === b + 1) && (f[1] === a + 1 || f[1] === b + 1))
    if (matchNumber < 0) {
      console.error(`${a} vs ${b} not found`)
    }

    return `M${matchNumber + 1}`
  }

  const sheetBreaks = (pool) => {
    const pages = []

    try {
      const matches = JSON.parse(JSON.stringify(matchData[pool?.participants?.length]))

      if (matches.length <= 10) {
        pages.push(matches)
      } else {
        while (matches.length > 0) {
          const deleted = matches.splice(0, 10)
          pages.push(deleted)
        }
      }
    } catch (err) {
      console.log(err)
    }

    return pages
  }

  return (
    <div ref={ref} className='print'>
      {pools.map((poolToPrint, poolIndex) =>
        <div key={`pool_${poolIndex}`}>
          <div className='score-grid-title'><h1>{squadronHelper.getColor(poolToPrint?.pool?.index)} Squadron</h1></div>
          <div className='score-grid'>
            <Row className='score-grid-label'>
              <Col span={Math.floor(24 - (poolToPrint?.pool?.participants?.length * 2))}> </Col>
              {poolToPrint?.matches.map((s, sindex) =>
                <Col key={`p${sindex}`} span={2}>
                  {sindex + 1}
                </Col>
              )}
            </Row>
            {poolToPrint?.matches.map((s, sindex) =>
              <Row key={`s${sindex}`}>
                <Col className='grid-row-label grid-cell' span={Math.floor(22 - (poolToPrint?.pool?.participants?.length * 2))} key={`p${sindex}`}>
                  <span>{poolToPrint?.pool?.participants?.[sindex]?.last_name}, {poolToPrint?.pool?.participants?.[sindex]?.first_name}</span>
                </Col>
                <Col className='score-grid-label' span={2}>
                  <span>{sindex + 1}</span>
                </Col>
                {s.map((p, pindex) =>
                  <Col span={2} key={`p${pindex}`} className={`grid-cell ${sindex === pindex ? 'blank-grid-cell' : ''}`}>
                    {sindex !== pindex ? <Input placeholder={getMatchNumber(poolToPrint?.pool?.participants?.length, sindex, pindex)} /> : ''}
                  </Col>
                )}
              </Row>
            )}
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gridGap: '1em', paddingTop: '2em' }}>
              {props.sheetLayout !== 'a' && props.sheetLayout !== 'c'
                ? matchData[poolToPrint?.pool?.participants?.length].map(m =>
                  <div key={`${m[0]}_${m[1]}`}>
                    {m[0]} vs {m[1]}
                  </div>
                )
                : ''}
            </div>
          </div>
          {props.sheetLayout === 'a' || props.sheetLayout === 'c'
            ? <div className='score-grid-match-list'>
              {poolToPrint.sheets.map((page, pageIndex) =>
                <Row key={pageIndex} className='score-grid-match-list-row page-break'>
                  <div style={{ position: 'absolute', top: 0 }}>{squadronHelper.getColor(poolToPrint?.pool?.index)} Squadron (page {pageIndex + 1} of {poolToPrint?.sheets.length})</div>
                  {page.map((m, index) =>
                    <Col span={8} key={index + (pageIndex * 10)} className='score-grid-match-list-item'>
                      <div className='score-grid-match-list-title'>{`M${index + (pageIndex * 10) + 1}`}</div>
                      <div className='score-grid-match-list-participants'>
                        <Row gutter={12}>
                          <Col span={3} className='score-grid-match-list-participant-number'>{m[0]}</Col>
                          <Col span={8} className='score-grid-match-list-participant'>{poolToPrint?.pool.participants[m[0] - 1].last_name}, {poolToPrint?.pool.participants[m[0] - 1].first_name}</Col>
                          <Col span={11}>
                            <Row>
                              {_.times(props?.config?.score, (num) =>
                                <Col className='score-grid-match-list-participants-score' span={Math.floor(24 / props?.config?.score)}>
                                  <div className='score-grid-match-list-participants-score-label-top'>{num + 1}</div>
                                  <span>{'\u00a0'}</span>
                                </Col>
                              )}
                            </Row>
                          </Col>
                        </Row>
                        <Row gutter={12}>
                          <Col span={3} className='score-grid-match-list-participant-number'>{m[1]}</Col>
                          <Col span={8} className='score-grid-match-list-participant'>{poolToPrint?.pool.participants[m[1] - 1].last_name}, {poolToPrint?.pool.participants[m[1] - 1].first_name}</Col>
                          <Col span={11}>
                            <Row>
                              {_.times(props?.config?.score, (num) =>
                                <Col className='score-grid-match-list-participants-score' span={Math.floor(24 / props?.config?.score)}>
                                  <div className='score-grid-match-list-participants-score-label-bottom'>{num + 1}</div>
                                  <span>{'\u00a0'}</span>
                                </Col>
                              )}
                            </Row>
                          </Col>
                        </Row>
                      </div>
                    </Col>
                  )}
                </Row>
              )}
            </div>
            : ''}

        </div>
      )}
    </div>
  )
})

export default PrintPools
